export const ICON_CATEGORIES = {
    navigation: {
        上: 'chevron--up',
        下: 'chevron--down',
        左: 'chevron--left',
        右: 'chevron--right',
        双左: 'arrow-double--left',
        双右: 'arrow-double--right',
        添加: 'add',
        减: 'subtract',
        关闭: 'close',
        微菜单: 'thumbnail--alt',
        打勾: 'check-small',
        首页_线性: 'home--outline',
        首页_实底: 'home--filled',
        应用_线性: 'apps--outline',
        应用_实底: 'apps--filled',
        搜索: 'search',
        放大: 'zoom-in',
        缩小: 'zoom-out',
        添加_线性: 'add--circle--outline',
        添加_实底: 'add--circle--filled',
        去除_线性: 'subtract--circle--outline',
        去除_实底: 'subtract--circle--filled',
        增加_线性: 'add--square--outline',
        增加_实底: 'add--square--filled',
        减少_线性: 'substract--square--outline',
        减少_实底: 'substract--square--filled',
        列表: 'list',
        菜单: 'hamburger',
        应用菜单: 'menu',
        更多: 'overflow-menu--horizontal',
        更多1: 'overflow-menu--vertical',
        返回顶部: 'up-to-top',
        去底部: 'down-to-bottom',
        斜杠: 'slash',
        模块_线性: 'module--outline',
        模块_填充: 'module--filled',
        列_线性: 'column--outline',
        列_填充: 'column--filled',
        项目_线性: 'agenda--outline',
        项目_填充: 'agenda--filled',
        轮播_线性: 'carousel--outline',
        轮播_填充: 'carousel--filled'
        // Chocolate: 'chocolate',
        // 'View module': 'view-module',
        // 'View column': 'view-column',
        // 'View agenda': 'view-agenda',
        // 'View carousel': 'view-carousel'
    },
    operations: {
        向右展开: 'put-away--right',
        向左收起: 'put-away--left',
        移动: 'move',
        拖拽: 'draggable',
        左上升: 'ascending',
        右下降: 'descending',
        最大化: 'maximize',
        最小化: 'minimize',
        切换: 'arrows--horizontal',
        排序: 'arrows--vertical',
        上箭头: 'arrow--up',
        下箭头: 'arrow--down',
        左箭头: 'arrow--left',
        右箭头: 'arrow--right',
        上1: 'caret--up',
        下1: 'caret--down',
        左1: 'caret--left',
        右1: 'caret--right',
        排序1: 'caret--sort',
        撤回: 'undo',
        重做: 'redo',
        升级: 'upgrade',
        退出: 'logout',
        进入: 'login',
        发送_线性: 'send--outline',
        //没有实底风格
        斜杠: 'slash',
        书签_线性: 'bookmark--outline',
        Flag: 'flag',
        筛选: 'filter',
        刷新: 'renew',
        //没有实底风格
        // 'Put-away-left',
        // 'Put-away-right',
        消息_线性: 'chat--outline',
        横向拖动: 'drag--horizontal',
        竖向拖动: 'drag--vertical',
        对比_线性: 'compare--outline',
        对比_填充: 'compare--filled',
        旗帜_线性: 'flag--outline',
        旗帜_填充: 'flag--filled',
        向内缩进: 'text--indent--more',
        向外缩进: 'text--indent--less',
        展开: 'unfold',
        收起: 'pack-up',
        反馈_线性: 'feedback--outline',
        反馈_填充: 'feedback--filled',
        随机: 'random'
    },
    toggle: {
        提示_线性: 'notification--outline',
        提示_实底: 'notification--filled',
        关闭提示_线性: 'notification--off--outline',
        关闭提示_实底: 'notification--off--filled',
        锁定_线性: 'locked--outline',
        锁定_实底: 'locked--filled',
        解锁_线性: 'unlocked--outline',
        解锁_实底: 'unlocked--filled',
        喜欢_线性: 'favorite--outline',
        喜欢_实底: 'favorite--filled',
        星星_线性: 'star--outline',
        星星_实底: 'star--filled',
        可见_线性: 'view--outline',
        可见_实底: 'view--filled',
        不可见_线性: 'view--off--outline',
        不可见_实底: 'view--off--filled',
        赞_线性: 'thumbs-up--outline',
        赞_实底: 'thumbs-up--filled',
        差劲_线性: 'thumbs-down--outline',
        差劲_实底: 'thumbs-down--filled',
        钉_线性: 'pin--outline',
        钉_实底: 'pin--filled',
        移除钉_线性: 'remove--fixed--outline',
        移除钉_填充: 'remove--fixed--filled',
        唤起_线性: 'awake--outline',
        唤起_填充: 'awake--filled',
        睡眠_线性: 'asleep--outline',
        睡眠_填充: 'asleep--filled',
        录音_线性: 'microphone--outline',
        录音_填充: 'microphone--filled',
        关闭录音_线性: 'microphone--off--outline',
        关闭录音_填充: 'microphone--off--filled',
        摄像机_线性: 'video--outline',
        摄像机_填充: 'video--filled',
        关闭摄像机_线性: 'video--off--outline',
        关闭摄像机_填充: 'video--off--filled'
        // 'Remove fixed': 'unpin',
        // Awake: 'awake',
        // Asleep: 'asleep'
    },
    formatting: {
        删除_线性: 'trash-can--outline',
        删除_实底: 'trash-can--filled',
        编辑_线性: 'edit--outline',
        编辑_实底: 'edit--filled',
        链接: 'Link-outlined',
        保存_线性: 'save--outline',
        保存_实底: 'save--filled',
        unlink: 'Unlink-outlined',
        attachment: 'Attachment-outlined',
        图片_线性: 'image--outline',
        图片_实底: 'image--filled',
        图片未显示_线性: 'no-image--outline',
        图片未显示_实底: 'no-image--filled',
        矩形_线性: 'rectangle--outline',
        矩形_填充: 'rectangle--filled',
        多边形_线性: 'polygon--outline',
        多边形_填充: 'polygon--filled',
        区域_线性: 'area--outline',
        区域_填充: 'area--filled',
        裁剪: 'crop',
        文本字号: 'text--scale',
        文字_线性: 'text--outline',
        文字_填充: 'text--filled',
        调色板_线性: 'color--palette--outline',
        调色板_填充: 'color--palette--filled',
        不可编辑_线性: 'edit--off--outline',
        不可编辑_填充: 'edit--off--filled',
        颜色_线性: 'color--outline',
        颜色_填充: 'color--filled',
        '3d动画_线性': 'animation--3d--mode--outline',
        '3d动画_填充': 'animation--3d--mode--filled'
        // Rectangle: 'rectangle',
        // Polygon: 'polygon',
        // Area: 'area',
        // Crop: 'crop',
        // Text: 'text',
        // Color: 'color',
        // 'Color palette': 'color-palette',
        // 'Edit off': 'edit--off',
        // 断开链接: 'unlink',
        // '3D animation model': '3d-animation-model'
    },
    controls: {
        播放_线性: 'play--outline',
        播放_实底: 'play--filled',
        停止_线性: 'stop--outline',
        停止_实底: 'stop--filled',
        暂停_线性: 'pause--outline',
        暂停_实底: 'pause--filled',
        设置_线性: 'settings--outline',
        设置_实底: 'settings--filled',
        播放1_线性: 'play--square--outline',
        播放1_实底: 'play--square--filled',
        停止1_线性: 'stop--square--outline',
        停止1_实底: 'stop--square--filled',
        暂停1_线性: 'pause--square--outline',
        暂停1_实底: 'pause--square--filled',
        设置1_线性: 'settings--alt--outline',
        设置1_实底: 'settings--alt--filled',
        大音量_线性: 'volume--up--outline',
        大音量_实底: 'volume--up--filled',
        小音量_线性: 'volume--down--outline',
        小音量_实底: 'volume--down--filled',
        调大音量_线性: 'volume--up--alt--outline',
        调大音量_实底: 'volume--up--alt--filled',
        关闭声音_线性: 'volume--mute--outline ',
        关闭声音_填充: 'volume--mute--filled',
        调整设置_线性: 'settings--adjust--outline',
        调整设置_填充: 'settings--adjust--filled'
        // 'Volume mute': 'a-Volumemute-outlined',
        // 'Settings adjust': 'a-Settingsadjust-outlined'
    },
    commerce: {
        购物车_线性: 'shopping--cart--outline',
        购物车_实底: 'shopping--cart--filled',
        礼物_线性: 'gift--outline',
        礼物_实底: 'gift--filled',
        商店_线性: 'store--outline',
        商店_实底: 'store--filled',
        商店管理_线性: 'store-management--outline',
        商店管理_实底: 'store-management--filled',
        品牌_线性: 'Brand--outline',
        品牌_填充: 'Brand--filled',
        会员_线性: 'VIP--outline',
        会员_填充: 'VIP--filled'
        // 'Brand management': 'brand-management',
        // 用户管理_线性: 'user-management--outline'
    },
    time: {
        日历_线性: 'calendar--outline',
        日历_实底: 'calendar--filled',
        时间_线性: 'time--alt--outline',
        时间_实底: 'time--alt--filled',
        时间1_线性: 'time--outline',
        时间1_实底: 'time--filled'
    },
    status: {
        正确_线性: 'checkmark--outline',
        正确_实底: 'checkmark--filled',
        错误_线性: 'misuse--outline',
        错误_实底: 'misuse--filled',
        警告_线性: 'warning--outline',
        警告_实底: 'warning--filled',
        帮助_线性: 'help--outline',
        帮助_实底: 'help--filled',
        提示_线性: 'information--outline',
        提示_实底: 'information--filled',
        禁止_线性: 'error--outline',
        禁止_实底: 'error--filled',
        对勾1_线性: 'checkmark',
        对勾1_实底: 'checkmark--filled',
        更多2_线性: 'pending--outline',
        更多2_实底: 'pending--filled',
        新_线性: 'new--outline',
        新_实底: 'new--filled',
        正确1_线性: 'checkmark--square--outline',
        正确1_实底: 'checkmark--square--filled',
        错误1_线性: 'misuse--square--outline',
        错误1_实底: 'misuse--square--filled',
        警告1_线性: 'warning--square--outline',
        警告1_实底: 'warning--square--filled',
        帮助1_线性: 'help--square--outline',
        帮助1_实底: 'help--square--filled',
        提示1_线性: 'information--square--outline',
        提示1_实底: 'information--square--filled',
        禁止1_线性: 'error--square--outline',
        禁止1_实底: 'error--square--filled',
        流程_线性: 'processing--outline',
        流程_填充: 'processing--filled'
        // Processing: 'processing',
        // 'New 1': 'a-New1-outlined'
    },
    technology: {
        wifi: 'wifi',
        电脑_线性: 'computer--outline',
        电脑_实底: 'computer--filled',
        下载: 'cloud--download',
        上传: 'cloud--upload',
        短信_线性: 'email--outline',
        短信_实底: 'email--filled',
        设备_线性: 'equipment--outline',
        设备_实底: 'equipment--filled',
        分享_线性: 'share--outline',
        分享_实底: 'share--filled',
        移动_线性: 'mobile--outline',
        移动_实底: 'mobile--filled',
        客服_线性: 'headset--outline',
        客服_实底: 'headset--filled',
        电话_线性: 'phone--outline',
        电话_实底: 'phone--filled',
        code: 'code',
        code_线性: 'code--alt--outline',
        code_实底: 'code--alt--filled',
        商圈_线性: 'business-access--outline',
        商圈_实底: 'business-access--filled',
        扫码: 'scanning',
        公文包_线性: 'gongwenbao_xianxing',
        公文包_实底: 'briefcase--filled',
        蓝牙: 'bluetooth',
        // 蓝牙_实底: 'bluetooth--filed',
        蓝牙断开: 'bluetooth--off',
        // 蓝牙断开_实底: 'bluetooth--off-filled',
        机器人_线性: 'bot--outline',
        机器人_实底: 'bot--filled',
        监控: 'cloud--monitoring',
        相机_线性: 'camera--outline',
        相机_填充: 'camera--filled',
        监督_线性: 'supervision--outline',
        监督_填充: 'supervision--filled',
        维基_线性: 'wikis--outline',
        维基_填充: 'wikis--filled',
        专利_线性: 'IP--outline',
        专利_填充: 'IP--filled',
        API_线性: 'api--outline',
        API_填充: 'api--filled',
        二维码_线性: 'QR-code--outline',
        二维码_填充: 'QR-code--filled',
        推荐工具: 'recommend--tools'
        // Camera: 'camera',
        // Supervision: 'supervision',
        // Wikis: 'wikis',
        // 'QR code': 'qr-code',
        // IP: 'ip',
        // API: 'api'
    },
    instruments: {
        尺子_线性: 'ruler--outline',
        尺子_填充: 'ruler--filled',
        三角尺_线性: 'ruler--alt--outline',
        三角尺_填充: 'ruler--alt--filled',
        摄像头_线性: 'webcam--outline',
        摄像头_填充: 'webcam--filled',
        望远镜_线性: 'telescope--outline',
        望远镜_填充: 'telescope--filled'
    },
    user: {
        用户_线性: 'user--outline',
        用户_实底: 'user--filled',
        用户组_线性: 'user--multiple--outline',
        用户组_实底: 'user--multiple--filled',
        开心_线性: 'face--satisfied--outline',
        开心_实底: 'face--satisfied--filled',
        伤心_线性: 'face--dissatisfied--outline',
        伤心_实底: 'face--dissatisfied--filled',
        中立_线性: 'face--neutral--outline',
        中立_实底: 'face--neutral--filled',
        添加用户_线性: 'user--follow--outline',
        添加用户_实底: 'user--follow--filled',
        打星用户_线性: 'user--certification--outline',
        打星用户_实底: 'user--certification--filled',
        选中用户_线性: 'user--admin--outline',
        选中用户_实底: 'user--admin--filled',
        用户管理_线性: 'user-management--outline',
        用户管理_实底: 'user-management--filled',
        商业目标_线性: 'business-competitor--outline',
        商业目标_实底: 'business-competitor--filled',
        企业用户_线性: 'enterprise-user',
        企业用户_实底: 'enterprise-user'
    },
    data: {
        气泡图_线性: 'chart--bubble--outline',
        气泡图_实底: 'chart--bubble--filled',
        条形图_线性: 'chart--column--outline',
        条形图_实底: 'chart--column--filled',
        数据_线性: 'data--base',
        数据_实底: 'data--base',
        // 'Database addition': 'data--add',
        架构图_线性: 'parent-child--outline',
        架构图_实底: 'parent-child--filled',
        图表_线性: 'chart--outline',
        图表_实底: 'chart--filled',
        饼图_线性: 'chart--pie--outline',
        饼图_实底: 'chart--pie--filled',
        面积图_线性: 'area--map--outline',
        面积图_实底: 'area--map',
        折线图: 'chart--line',
        添加数据: 'database--addition',
        仪表盘_线性: 'dashboard--outline',
        仪表盘_填充: 'dashboard--filled'
        // Dashboard: 'dashboard'
    },
    file: {
        文件_线性: 'document--outline',
        文件_实底: 'document--filled',
        文件夹_线性: 'folder--outline',
        文件夹_实底: 'folder--filled',
        输出: 'export',
        下载1: 'download',
        上传1: 'upload',
        添加文件_线性: 'document--add',
        拷贝_线性: 'copy--outline',
        拷贝_实底: 'copy--filled',
        添加文件夹_线性: 'folder--add--outline',
        添加文件夹_实底: 'folder--add--filled',
        打开文件夹_线性: 'folder--open',
        文件夹详情_线性: 'folder--details--outline',
        文件夹详情_实底: 'folder--details--filled',
        文件详情_线性: 'details--outline',
        文件详情_实底: 'details--filled',
        安全_线性: 'security--outline',
        安全_实底: 'security--filled',
        视频文件_线性: 'document--video--outline',
        视频文件_填充: 'document--video--filled',
        音频文件_线性: 'document--music--outline',
        音频文件_填充: 'document--music--filled',
        黑名单_线性: 'blacklist--outline',
        黑名单_填充: 'blacklist--filled',
        撤回: 'withdraw',
        问答_线性: 'QA--outline',
        问答_填充: 'QA--filled',
        HTTP_线性: 'http--outline',
        HTTP_填充: 'http--filled',
        查找_线性: 'seek--outline',
        查找_填充: 'seek--filled',
        确认_线性: 'confirm--outline',
        确认_填充: 'confirm--filled',
        PDF: 'file--pdf',
        ZIP: 'file--zip',
        XLS: 'file--xls',
        WORD: 'file--word',
        PNG: 'file--png',
        PPT: 'file--ppt',
        NPS: 'file--nps',
        问卷_线性: 'questionnaire--outline',
        问卷_填充: 'questionnaire--filled',
        包裹_线性: 'package--outline',
        包裹_填充: 'package--filled'
        // ''Copy 1': 'a-Copy1-outlined',
        // 'Query file': 'a-Queryfile-outlined', //不在已产出和未产出中
        // Data: 'Data-outlined', //不在已产出和未产出中
        // 'Video file': 'a-Videofile-outlined', //不在已产出和未产出中
        // Blacklist: 'Blacklist-outlined', //不在已产出和未产出中
        // PDF: 'PDF-outlined', //不在已产出和未产出中
        // ZIP: 'ZIP-outlined', //不在已产出和未产出中
        // XLS: 'XLS-outlined', //不在已产出和未产出中
        // WORD: 'WORD-outlined', //不在已产出和未产出中
        // PNG: 'PNG-outlined', //不在已产出和未产出中
        // EXL: 'EXL-outlined', //不在已产出和未产出中
        // PPT: 'PPT-outlined', //不在已产出和未产出中
        // NPS: 'NPS-outlined', //不在已产出和未产出中
        // Withdraw: 'Withdraw-outlined', //不在已产出和未产出中
        // Http: 'Http-outlined', //不在已产出和未产出中
        // 可见_线性: 'view--outline',
        // Confirm: 'Confirm-outlined', //不在已产出和未产出中
        // Questionnaire: 'Questionnaire-outlined' //不在已产出和未产出中'
        //没有实底风格
        // 'Datepackage '
    },
    senses: { 想法_线性: 'idea--outline', 想法_实底: 'idea--filled' },
    travel: {
        地点_线性: 'location--outline',
        地点_实底: 'location--filled',
        地图_线性: 'map--outline',
        地图_实底: 'map--filled',
        定位_线性: 'target--outline',
        定位_填充: 'target--filled'
        // 'Airport location': 'airport-location'
    },
    other: {
        打印_线性: 'printer--outline',
        打印_实底: 'printer--filled',
        人民币: 'CNY',
        美元: 'dollar',
        钉钉: 'dingding',
        分隔线: 'separator',
        ATM_线性: 'atm--outline',
        ATM_填充: 'atm--filled',
        推荐_线性: 'recommend--outline',
        推荐_填充: 'recommend--filled',
        徽章_线性: 'badge--outline',
        徽章_填充: 'badge--filled',
        奖杯_线性: 'trophy--outline',
        奖杯_填充: 'trophy--filled'
        // 'Regional thermal': 'regional-thermal',
        // 'Use a line separating': 'use-a-line-separating',
        // Atm: 'atm',
        // 'Official proprietary': 'official-proprietary',
        // 'Third party': 'third-party'
    }
};
